import { Checkbox, Input, Select } from "components"
import { FilterTypeSetStockByLocation } from "../types/SetStockByLocationType"
import { useProductCategory } from "pages/Inventori/Register/utils"
import { useLocation } from "utils"

type Props = {
    isList?: boolean
    filter: FilterTypeSetStockByLocation
    setFilter: React.Dispatch<React.SetStateAction<FilterTypeSetStockByLocation>>
}

export function Filter({ filter, setFilter, isList }: Props) {
    

    // hooks
    const { dataCategory, isLoadingCategory } = useProductCategory();
    const { data: location, isLoading: isLoadingLocation } = useLocation()

    const locationOption = isList ? [{ label: "ALL", value: "" }].concat(location) : location

    return (
        <div className="lg:flex lg:justify-between items-start mb-5">
            <div className="flex flex-col gap-5 mb-2">
                <div>
                    <Input
                        label="SEARCH"
                        className="lg:w-[300px] md:w-full"
                        placeholder="Search data..."
                        onChange={res => {
                            setFilter({ ...filter, keyword: res.target.value })
                        }}
                    />
                </div>
                <div className="flex items-center gap-3">
                    <Checkbox
                        defaultChecked={filter?.buy}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                buy: e.target.checked ?? "",
                            })
                        }
                    >
                        BUY
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.sell}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                sell: e.target.checked ?? "",
                            })
                        }
                    >
                        SELL
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.inv}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                inv: e.target.checked ?? "",
                            })
                        }
                    >
                        INVENTORY
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.build}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                build: e.target.checked ?? "",
                            })
                        }
                    >
                        BUILD
                    </Checkbox>
                </div>
            </div>

            <div className="flex flex-col gap-5">
                <div className="lg:flex gap-2">

                    <Select
                        label="LOCATION"
                        placeholder="Select location here..."
                        className="lg:w-[200px] w-full me-2 mb-2"
                        width={true}
                        isLoading={isLoadingLocation}
                        defaultValue={ isList ? { value: "", label: "ALL" }: null}
                        options={locationOption}
                        value={location.find(
                            (item) => item.value === filter?.location_id?.toString()
                        )}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                location_id: e?.value ?? "",
                                location_name: e?.label ?? "",
                            })
                        }
                    />

                    <Select
                        label="CATEGORY"
                        placeholder="Select product category here..."
                        className="lg:w-[200px] w-full me-2 mb-2"
                        width={true}
                        defaultValue={{ value: "0", label: "ALL" }}
                        isLoading={isLoadingCategory}
                        options={[{ label: "ALL", value: "" }].concat(
                            dataCategory
                        )}
                        value={dataCategory.find(
                            (item) => item.value === filter?.category_id
                        )}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                category_id: e?.value ?? "",
                            })
                        }
                    />
                </div>

                <div className="flex items-center gap-3">
                    <Checkbox
                        defaultChecked={filter?.zero_soh}
                        disabled={!filter.location_id}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                zero_soh: e.target.checked ?? "",
                            })
                        }
                    >
                        Zero SOH
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.zero_min}
                        disabled={!filter.location_id}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                zero_min: e.target.checked ?? "",
                            })
                        }
                    >
                        Zero Min
                    </Checkbox>

                    <Checkbox
                        defaultChecked={filter?.zero_max}
                        disabled={!filter.location_id}
                        onChange={(e) =>
                            setFilter({
                                ...filter,
                                zero_max: e.target.checked ?? "",
                            })
                        }
                    >
                        Zero Max
                    </Checkbox>
                </div>
            </div>
        </div>
    )
}
